var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManageBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208-253.999v-319.335h66.667v319.335H208Zm241.334 0v-319.335H516v319.335h-66.666ZM80-120.667v-66.666h800v66.666H80Zm605.333-133.332v-319.335H752v319.335h-66.667ZM80-640v-61.999l400-218.668 400 218.668V-640H80Zm148.666-66.666h502.668-502.668Zm0 0h502.668L480-844.667 228.666-706.666Z",
    fill: "#5D616D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageBank);
export default __webpack_public_path__ + "static/media/Manage Bank.f840d4bad67c99812fd6a7760610f477.svg";
export { ForwardRef as ReactComponent };